import { API } from "../../api";
async function update_user_details(request) {
    // console.log("update_user_details -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `user/update`, //
        content: request,
    });
}
export { update_user_details };
